
export const RESET_SERVER_ERROR = 'RESET_SERVER_ERROR'
export const SERVER_ERROR = 'SERVER_ERROR'

export const resetServerError = () => dispatch => {
  dispatch({ type: RESET_SERVER_ERROR })
}

// export const serverError = payload => dispatch => {
//   dispatch({ type: SERVER_ERROR, payload })
// }
